import * as Yup from "yup";


function replaceDecimalSeparator(value: any): any {
    return value.toString().replace(',', '.');
}


export type ValidOre = {
  nrrel?: number;
  ref?: string;
  dataval?: Date;
};

export function mapValidOreToJson(validOre: ValidOre): any {
  return {
    BT80_NRREL: validOre.nrrel,
    BT80_REF: validOre.ref,
    BT80_DATAVAL: validOre.dataval,
  };
}


export type ValVersOreDTO = {
  nrrel?: number;
  desditta?: string;
  datareg?: Date | null;
  coddip?: string;
  oreord?: number;
  minord?: number;
  note?: string;
  datains?: Date | null;
  nomeagente?: string;
  ref?: string;
  flgval?: string;
  desprog?: string;
  ore?: number;
  oremin?: string;
  emailclientetimereport?: string,
  opzione?: string,
  flgdisabled?: string;
  ragsoccli?:string;
};


export type ValVersOreDTOApiResponse = {
  results: Array<ValVersOreDTO>;
  count: number;
};

export function mapJsonToValVersOreDTOApiResponse(jsonData: any): ValVersOreDTOApiResponse {
  const mappedData: ValVersOreDTOApiResponse = {
    count: jsonData.count,
    results: jsonData.results.map((item: any) => ({
      nrrel: item.VBT80_NRREL,
      desditta: item.VBT80_DESDITTA,
      datareg: item.VBT80_DATAREG,
      coddip: item.VBT80_CODDIP,
      oreord: item.VBT80_OREORD,
      minord: item.VBT80_MINORD,
      note: item.VBT80_NOTE,
      datains: item.VBT80_DATAINS,
      nomeagente: item.VBT80_NOMEAGENTE,
      ref: item.VBT80_REF,
      flgval: item.VBT80_FLGVAL,
      desprog: item.VBT80_DESPROG,
      ore: item.VBT80_ORE,
      oremin: item.VBT80_OREMIN,
      emailclientetimereport: item.VBT80_EMAILCLIENTETIMEREPORT,
      opzione: item.VBT80_OPZIONE,
      flgdisabled: item.VBT80_FLGDISABLED,
      ragsoccli: item.VBT80_RAGSOCCLI,
    })),
  };

  return mappedData;
}

